import type { IconProps } from '../types';

export function ViewIcon({ className, title }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      preserveAspectRatio="xMidYMid meet"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
    >
      {title ? <title>{title}</title> : null}
      <circle cx="50" cy="43.98" r="11.18" fill="currentColor" />
      <path
        d="M93,46.74c-.66-.92-16.34-22.61-43-22.61S7.66,45.82,7,46.74a1.46,1.46,0,0,0,0,1.69C7.66,49.35,23.34,71,50,71s42.34-21.68,43-22.6A1.46,1.46,0,0,0,93,46.74ZM61.58,28.58a1.55,1.55,0,0,0,.3.33,19.19,19.19,0,1,1-23.54-.17,2,2,0,0,0,.21-.19,44.24,44.24,0,0,1,23,0ZM50,68.12c-22.23,0-36.81-16.57-40-20.54A59.52,59.52,0,0,1,32.37,30.65a22.1,22.1,0,1,0,35.26,0A59.61,59.61,0,0,1,90,47.58C86.81,51.55,72.23,68.12,50,68.12Z"
        fill="currentColor"
      />
    </svg>
  );
}
